/**
 * Gestor Calendar Service — G1 (Temporadas/Fases)
 *
 * Backend: /api/gestor/calendar/*  (tenant SEMPRE resolvido no backend via RBAC)
 * Fonte operacional canônica de fases: dbo.schedule_blocks.
 */
import { AZURE } from './api';

export const PHASE_TYPES = ['BASE', 'BUILD', 'PEAK', 'TAPER', 'COMPETITION', 'RECOVERY', 'TRANSITION'];

export const PHASE_LABELS = {
  BASE: 'Base', BUILD: 'Build', PEAK: 'Pico', TAPER: 'Taper',
  COMPETITION: 'Competição', RECOVERY: 'Recuperação', TRANSITION: 'Transição',
};

export const PHASE_COLORS = {
  BASE: '#0ea5e9', BUILD: '#064e3b', PEAK: '#b48c2c', TAPER: '#8b5cf6',
  COMPETITION: '#ef4444', RECOVERY: '#10b981', TRANSITION: '#6b7280',
};

export const getSeasons = async () => {
  const { data } = await AZURE.get('/gestor/calendar/seasons');
  return data.data || [];
};

export const createSeason = async (payload) => {
  const { data } = await AZURE.post('/gestor/calendar/seasons', payload);
  return data.data;
};

export const getCalendarBlocks = async (seasonId) => {
  const { data } = await AZURE.get('/gestor/calendar/blocks', {
    params: seasonId ? { season_id: seasonId } : {},
  });
  return data.data || [];
};

export const createCalendarBlock = async (payload) => {
  const { data } = await AZURE.post('/gestor/calendar/blocks', payload);
  return data.data;
};

export const updateCalendarBlock = async (blockId, updates) => {
  const { data } = await AZURE.put(`/gestor/calendar/blocks/${blockId}`, updates);
  return data.data;
};

export const cancelCalendarBlock = async (blockId) => {
  const { data } = await AZURE.delete(`/gestor/calendar/blocks/${blockId}`);
  return data.data;
};

/**
 * Fase vigente para data+atleta (precedência GROUP > CATEGORY > CLUB).
 * Consumidores (Coach/Prep/Nutri/Atleta) usam isto — nunca redefinem fase.
 * @returns {Promise<{phase, block_name, start_date, end_date, scope}|null>}
 */
export const resolvePhase = async ({ date, athleteUserId } = {}) => {
  const params = {};
  if (date) params.date = date;
  if (athleteUserId) params.athlete_user_id = athleteUserId;
  const { data } = await AZURE.get('/gestor/calendar/resolve', { params });
  return data.data; // null quando não há fase definida
};

/**
 * G2 — Calendário Unificado: fonte única de eventos multi-área.
 * Backend: GET /api/gestor/calendar/events (read-only aggregator).
 * @returns {Promise<{events: Array, phases: Array}>}
 */
export const getUnifiedEvents = async ({ dateFrom, dateTo, area, category, squadId, athleteUserId } = {}) => {
  const params = { date_from: dateFrom, date_to: dateTo };
  if (area && area !== 'all') params.area = area;
  if (category) params.category = category;
  if (squadId) params.squad_id = squadId;
  if (athleteUserId) params.athlete_user_id = athleteUserId;
  const { data } = await AZURE.get('/gestor/calendar/events', { params });
  return data.data || { events: [], phases: [] };
};
